<div class="login-page" role="main">
  <mat-card class="login-card" aria-labelledby="loginTitle">
    <h1 id="loginTitle" class="title">Sign in</h1>
    @if (errorMessage()) {
      <p class="error-banner" role="alert">{{ errorMessage() }}</p>
    }
    <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input
          matInput
          placeholder="you@example.com"
          formControlName="email"
          type="email"
          required
          aria-required="true"
        />
        @if (form.get('email')?.invalid && form.get('email')?.touched) {
          <mat-error>Please enter a valid email</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input
          matInput
          placeholder="Password"
          formControlName="password"
          [type]="hide ? 'password' : 'text'"
          required
          aria-required="true"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="toggleHide()"
          [attr.aria-label]="hide ? 'Show password' : 'Hide password'"
        >
          <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (form.get('password')?.hasError('required') && form.get('password')?.touched) {
          <mat-error>Password is required</mat-error>
        }
        @if (form.get('password')?.hasError('minlength') && form.get('password')?.touched) {
          <mat-error>Password must have at least 6 characters</mat-error>
        }
      </mat-form-field>

      <div class="actions">
        <button
          mat-flat-button
          color="primary"
          class="full-width"
          type="submit"
          [disabled]="form.invalid || submitting()"
        >
          {{ submitting() ? 'Signing in...' : 'Sign in' }}
        </button>
        <a class="forgot-link" routerLink="/forgot-password">Forgot password?</a>
      </div>
    </form>
  </mat-card>
</div>
